/* unplugin-vue-components disabled */import { render } from "./ShopInfoTable.vue?vue&type=template&id=41744cd2&scoped=true"
import script from "./ShopInfoTable.vue?vue&type=script&lang=js"
export * from "./ShopInfoTable.vue?vue&type=script&lang=js"

import "./ShopInfoTable.vue?vue&type=style&index=0&id=41744cd2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41744cd2"]])

export default __exports__